// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2TBbT","content":"Consent_content__2yLl4","footer":"Consent_footer__17Zqd"};